import React from 'react';
import { useParams } from 'react-router-dom';
import { useGetDealRowQuery } from '@/features/deals/dealsApi';
import RecordRouteGuard from '.';

export const DealRouteGuard = ({ children }) => {
	const { dealId } = useParams();
	const { currentData, isLoading, isFetching, isUninitialized, error } =
		useGetDealRowQuery(dealId);

	return (
		<RecordRouteGuard
			id={dealId}
			record={currentData}
			isLoading={isLoading || isFetching || isUninitialized}
			error={error}
			label='deal'
		>
			{children}
		</RecordRouteGuard>
	);
};
